import { useEffect, useState } from 'react';
import markerSDK from '@marker.io/browser';
import { Outlet } from "react-router-dom";
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import Notification from './components/Notification';

const drawerWidth = 336;

function App(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const user = useSelector(state => state.user);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const markerProject = process.env.REACT_APP_MARKER_PROJECT;

    const initialiseMarkerSDK = async () => {
      if (!markerProject) { return; }

      try {
        await markerSDK.loadWidget({
          project: markerProject,
        });
      } catch (error) {
        // Ad blockers and strict privacy settings can block Marker requests.
        // Do not fail app startup if the feedback widget cannot be loaded.
        console.warn('Marker SDK failed to initialise', error);
      }
    };

    initialiseMarkerSDK();
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Box
        component="main"
        sx={{ flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Box
          sx={{}}
        >
          <Notification />
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default App;
